export const CHALLENGE_ABI = [
  {
    type: 'function',
    name: 'state',
    inputs: [],
    outputs: [{ type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'creator',
    inputs: [],
    outputs: [{ type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'challengeType',
    inputs: [],
    outputs: [{ type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'startTime',
    inputs: [],
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'endTime',
    inputs: [],
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'minParticipants',
    inputs: [],
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'maxParticipants',
    inputs: [],
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'entryFee',
    inputs: [],
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'winnerCount',
    inputs: [],
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'participantCount',
    inputs: [],
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getRoundDeadlines',
    inputs: [],
    outputs: [{ type: 'uint256[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'isParticipant',
    inputs: [{ name: '', type: 'address' }],
    outputs: [{ type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'isWinner',
    inputs: [{ name: '', type: 'address' }],
    outputs: [{ type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'claimed',
    inputs: [{ name: '', type: 'address' }],
    outputs: [{ type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'payoutPerWinner',
    inputs: [],
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'processedRounds',
    inputs: [{ name: '', type: 'uint256' }],
    outputs: [{ type: 'bool' }],
    stateMutability: 'view',
  },
  { type: 'function', name: 'join', inputs: [], outputs: [], stateMutability: 'payable' },
  { type: 'function', name: 'refund', inputs: [], outputs: [], stateMutability: 'nonpayable' },
  {
    type: 'function',
    name: 'refunded',
    inputs: [{ name: '', type: 'address' }],
    outputs: [{ type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'eliminated',
    inputs: [{ name: '', type: 'address' }],
    outputs: [{ type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'proofHash',
    inputs: [
      { name: '', type: 'address' },
      { name: '', type: 'uint256' },
    ],
    outputs: [{ type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'participants',
    inputs: [{ name: '', type: 'uint256' }],
    outputs: [{ type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'submitProof',
    inputs: [
      { name: 'cidHash', type: 'bytes32' },
      { name: 'round', type: 'uint256' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'fileReport',
    inputs: [
      { name: 'target', type: 'address' },
      { name: 'round', type: 'uint256' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'invalidateProof',
    inputs: [
      { name: 'participant', type: 'address' },
      { name: 'round', type: 'uint256' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    name: 'Joined',
    inputs: [
      { indexed: true, name: 'participant', type: 'address' },
      { indexed: false, name: 'paid', type: 'uint256' },
    ],
  },
  {
    type: 'event',
    name: 'ProofSubmitted',
    inputs: [
      { indexed: true, name: 'participant', type: 'address' },
      { indexed: false, name: 'round', type: 'uint256' },
      { indexed: false, name: 'cidHash', type: 'bytes32' },
    ],
  },
  {
    type: 'event',
    name: 'Eliminated',
    inputs: [{ indexed: true, name: 'participant', type: 'address' }],
  },
  {
    type: 'event',
    name: 'ReportFiled',
    inputs: [
      { indexed: true, name: 'reportId', type: 'uint256' },
      { indexed: true, name: 'reporter', type: 'address' },
      { indexed: false, name: 'target', type: 'address' },
      { indexed: false, name: 'round', type: 'uint256' },
    ],
  },
  {
    type: 'function',
    name: 'claim',
    inputs: [],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'getWinners',
    inputs: [],
    outputs: [{ type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'event',
    name: 'ChallengeFinalized',
    inputs: [
      { indexed: false, name: 'winnerCount', type: 'uint256' },
      { indexed: false, name: 'payoutPerWinner', type: 'uint256' },
    ],
  },
] as const
